import { deriveCaseManagementWarning, showCaseManagement } from '~support-at-home/lib/derive';
import { validateDateRange } from '~support-at-home/lib/validate';

import { Definition } from '~components/form-fields/Fields';

import { getAll as getAllClientBudgetStatuses } from '~support-at-home/actions/clientBudgetStatuses';

import { selectClientBudgetStatuses } from '~support-at-home/selectors/clientBudgetStatuses';

const fields: Definition[] = [
  {
    key: 'start_date',
    type: 'date',
    caption: 'Start Date',
    validate: validateDateRange,
    order: 100,
  },
  {
    key: 'end_date',
    type: 'date',
    caption: 'End Date',
    validate: validateDateRange,
    order: 200,
  },
  {
    key: 'status_id',
    type: 'select',
    caption: 'Status',
    selectorActions: getAllClientBudgetStatuses,
    selectorOptions: selectClientBudgetStatuses,
    order: 300,
  },
  {
    key: 'total_amount',
    type: 'currency',
    caption: 'Total Amount',
    order: 400,
  },
  {
    key: 'total_includes_case_management',
    type: 'switch',
    caption: 'Includes Case Management',
    show: showCaseManagement,
    deriveWarning: deriveCaseManagementWarning,
    order: 500,
  },
];

export default fields;
